<style src="./SuggestClient.scss" lang="scss" scoped></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    v-model="inputValue"
    :rules="rules"
    min="2">

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="short-name">{{ item.shortName }}</span>
        <span class="full-name">{{ item.name }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import { InputSuggest, InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { IconCalendar, IconGenderFemale, IconUser, IconCard } from '@/components/primitives/icons'
import { SearchClientByName } from '@/brain/record/client'

export default {
  name: 'SuggestClient',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem,
    IconCalendar,
    IconGenderFemale,
    IconCard,
    IconUser
  },
  data () {
    return {
      captionRaw: 'shortName'
    }
  },
  methods: {
    doSearch (pSearchTerm) {
      return SearchClientByName({ clientName: pSearchTerm })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/suggest-client/SuggestClient.vue